import { useQuery } from '@tanstack/react-query';
import api from '@api/http/api';

interface PatchNote {
  id: number;
  date: string;
  notes: string[];
  thanks?: string[];
}

export function useStatusQuery() {
  return useQuery<{ newPlayer: boolean; jwt: string; id: string; }>({
    queryFn: () => api.get('/public/status'),
    queryKey: ['status'],
  });
}

export function usePatchnotesQuery() {
  return useQuery<PatchNote[]>({
    queryFn: () => api.get('/public/patchnotes'),
    queryKey: ['patchnotes'],
  });
}
